import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import EmptyIcon from "../../../../Shared/EmptyIcon";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import TableFilter from "../../../../Shared/tableFilter";
import { filterType } from "../../../../../helpers/filterHelper";
import DataGrid, { Column, RemoteOperations, Paging, Pager } from "devextreme-react/ui/data-grid";
import validaciones from "../../../../../helpers/validaciones";
import { Button } from "devextreme-react";
import { doGetFiltrosCupos, doGetCupos, openCloseModalEliminarCupo, openCloseModalEditarCupo, doGetCupoById } from "./action";
import ModalDelete from "./modalDelete";
import ModalEditar from "./modalEditar";
import ModalDesactivar from "./modalDesactivar";


class Cupos extends React.PureComponent {
  constructor(props) {
    super(props);

    if (!this.props.filtrosCupos) this.props.dispatch(doGetFiltrosCupos());
    this.props.dispatch(doGetCupos(null, true));
  }

  handleAdd = () => {
    this.props.dispatch(openCloseModalEditarCupo(true, {}, true));
  }

  handleDelete = (e) => {
    this.props.dispatch(openCloseModalEliminarCupo(true, e.data));
  }

  handleFilterChange = (text, filters) => {
    const currentFilters = [...filters];
    if (text) currentFilters.push({ column: "Description", value: { text, value: text }, type: filterType.search });
    this.props.dispatch(doGetCupos(currentFilters));
  }

  handleEdit = (e) => {
    this.props.dispatch(doGetCupoById(e.data));
  }

  render() {
    const { listaCuposFiltrados } = this.props;
    return (
      <React.Fragment>
        {this.props.isLoading && <LoadingOverlay />}
        <ModalDelete />
        <ModalEditar />
        <ModalDesactivar />
        <TableFilter
          placeholder="Buscar cupo"
          onChange={this.handleFilterChange}
          filters={this.props.filtrosCupos}
          show
          format="#,##0.##"
          buttons={{
            filter: { buttonName: "iconFilter", visible: true, buttonAction: null },
            document: { buttonName: "iconDocument", visible: false, buttonAction: null },
            download: { buttonName: "iconDownload", visible: false, buttonAction: null },
            newItem: {
              buttonName: "custom", visible: true, buttonAction: this.handleAdd, buttonText: "Agregar cupo",
            },
          }}
        />

        <DataGrid
          dataSource={listaCuposFiltrados}
          noDataText=""
          className="custom-table"
          showBorders={false}
          showColumnLines={false}
          allowColumnResizing={false}
          columnAutoWidth={false}
          showRowLines={false}
          rowAlternationEnabled
          onContentReady={(e) => {
            if (e.component.totalCount() === 0) {
              const config = {};
              config.addClass = "table-margin";
              const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
              const element = validaciones.noDataDOMElement(config, "Sin Cupos");
              noDataSpan.appendChild(element);
            }
          }}
        >
          <Column
            dataField="Description"
            allowSearch
            caption="Cupo"
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <div className="group-Column-inline">
                  {row.data.Procesando ?
                    <div className="material-icons" style={{ fontSize: "inherit" }}>schedule</div>
                    :
                    <EmptyIcon size={13} full={row.data.Status} />}
                  <div className="text space-text"> {row.data.Description}</div>
                </div>
                , element
              );
            }}
          />

          <Column
            alignment="center"
            dataField="Overbook"
            caption="Sobrecupo"
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <span>{row.data.Overbook ? "Si" : "No"}</span>
                , element
              );
            }}
          />

          <Column
            alignment="center"
            dataField="OverbookedMaximumAmount"
            caption="Cantidad máxima de sobrecupo"
          />

          <Column
            caption=""
            alignment="center"
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <div className="button-column">
                  <Button
                    className="slimButton"
                    style={{ marginRight: 5 }}
                    type="success"
                    text="Editar"
                    onClick={() => this.handleEdit(row)}
                  />

                  <Button
                    disabled={!!row.data.Status}
                    className="slimButton"
                    type="danger"
                    text="Eliminar"
                    onClick={() => this.handleDelete(row)}
                  />
                </div>
                , element
              );
            }}
          />
          <RemoteOperations
            paging={false}
            filtering
            summary={false}
            groupPaging={false}
            grouping={false}
            sorting={false}
          />

          <Paging
            defaultPageSize={10}
          />

          <Pager
            showNavigationButtons
            showInfo
            infoText={(page, total) => `Página ${page} de ${total}`}
          />

        </DataGrid>


      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.mantenedorCupos.isLoading,
  listaCupos: state.mantenedorCupos.listaCupos,
  listaCuposFiltrados: state.mantenedorCupos.listaCuposFiltrados,
  filtrosCupos: state.mantenedorCupos.filtrosCupos,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});
export default connect(mapStateToProps, mapDispatchToProps)(Cupos);
